export const zhanuzakova = {
  id: 'zhanuzakova',
  name: {
    ru: 'Жанузакова Амангуль Серикбаевна',
    kz: 'Жанұзақова Амангүл Серікбайқызы',
  },
  position: {
    ru: 'Врач-эпидемиолог',
    kz: 'Эпидемиолог дәрігер',
  },
  department: 'sportmed',
  education: {
    ru: `2009–2014 — Западно-Казахстанский государственный медицинский университет имени М. Оспанова, высшее медицинское образование`,
    kz: `2009–2014 — М. Оспанов атындағы Батыс Қазақстан мемлекеттік медицина университеті, жоғары медициналық білім`,
  },
  work: {
    ru: `• 20.08.2014–29.12.2017 — ГККП «Центр по профилактике и борьбе со СПИД» акимата г. Астаны
- 04.01.2018–31.07.2018 — Национальный научный центр материнства и детства КФ «UMC», г. Астана
- 01.09.2018–02.10.2023 — ТОО «Astana Vision»
- 10.09.2018 — по настоящее время — РГП на ПХВ «Национальный координационный центр экстренной медицины» МЗ РК`,
    kz: `• 20.08.2014–29.12.2017 — Астана қаласы әкімдігінің ГКҚП «ЖИТС-тің алдын алу және онымен күрес орталығы»
- 04.01.2018–31.07.2018 — «UMC» КҚ Ұлттық ана мен бала ғылыми орталығы, Астана қ.
- 01.09.2018–02.10.2023 — «Astana Vision» ЖШС
- 10.09.2018 — қазіргі уақытқа дейін — ҚР ДСМ «Ұлттық жедел медицина үйлестіру орталығы» ШЖҚ РМК`,
  },
};
